module.exports = "<a href=\"#paquickQuote\" class=\"gw-slq-link\">\r\n    <img class=\"slq-car-icon\" src=\"../styles/images/common/icons/car-profile-speedline.png\"/>\r\n    <span class=\"gw-slq-link-text\">{{'quoteandbind.views.zip-code.Get a Quick Quote' | translate }}</span>\r\n</a>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/quoteandbind/quickquote/directives/templates/quick-quote-link.html
// module id = 629
// module chunks = 0